module.exports = __webpack_public_path__ + "static/banner_home_mobile-261f6818fd026d9fea2067375c18e7e4.jpg";